if (!window.CrunchClassManager) {
  window.CrunchClassManager = require('crunch-class-manager').default
}
